import React from 'react';
import styles from './style.module.css';
import IframeResize from "../../../../common/components/iframe-resize";

export default () => (
    <div className={styles.page}>
        <h1 className={'invisible'}>Tax Benefits of an RESP Calculator</h1>
        <iframe src="https://www.financialcalculators.net/librocu/resp-tax-benefits/" title="Tax Benefits of an RESP Calculator" scrolling="no" frameBorder="0"> </iframe>
        <IframeResize />
    </div>
);
